import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import TicketsManagement from './Tickets/Tickets';
import baseURL from '../config';
import PageLoader from '../../../Reusable/PageLoader';
import { toast } from 'react-toastify';

const Tickets = () => {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchTickets = async () => {
        setLoading(true);
        try {
        // await new Promise(resolve => setTimeout(resolve, 4000));

            const response = await fetch(`${baseURL}/admin/tickets`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch tickets.');
            }

            const data = await response.json();
            setTickets(data);
        } catch (error) {
            console.error("Error fetching tickets:", error);
            toast.error(error.message || "An unexpected error occurred while fetching tickets.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTickets();
    }, []);

    const handleUpdateTickets = () => {
        fetchTickets();
    };

    if (loading) {
        return (
            <DashboardLayout>
                <PageLoader message="Loading tickets data..." />
            </DashboardLayout>
        );
    }
    
    // The conditional rendering for 'error' is removed because toast handles it.

    return (
        <DashboardLayout>
            <Typography
                variant="h6"
                sx={{
                    color: '#666',
                    marginBottom: 2,
                    textAlign: 'left',
                    marginTop: 2,
                    fontWeight: '600',
                }}
            >
                Overview
            </Typography>

            <TicketsManagement tickets={tickets} onUpdate={handleUpdateTickets} />
        </DashboardLayout>
    );
};

export default Tickets;